import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
declare let gtag: Function;

@Component({
  selector: 'rm-root',
  template: `
    <div class="container-fluid">
      <div class="inner-wrapper">
        <div class="row">
          <rm-nav></rm-nav>
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>
    <rm-footer></rm-footer>
  `,
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit() {
    this.setUpAnalytics();
  }

  setUpAnalytics() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)).subscribe(
      (event: NavigationEnd) => {
        gtag('config', 'G-WMMD8Z3C9P',
          {
            page_path: event.urlAfterRedirects
          }
        );
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts